export default __webpack_public_path__ + "static/media/SwitchesImg.9bc0cda5.jpg";